export default __webpack_public_path__ + "static/media/buffer.f38e0f6f.gif";